export interface IReservationRequestPayload {
  restourantId: string;
  startsAtUtc: string;
  partySize: number;
  contactName: string;
  contactPhone: string;
  note?: string;
  captchaToken: string;
}

export interface IReservationRequestResponse {
  reservationId: string;
  codeLifetimeMinutes: number;
}

export interface IVerifyReservationPayload {
  reservationId: string;
  code: string;
}

export interface IResendCodePayload {
  reservationId: string;
}

export enum CancellationReason {
  Unspecified = 0,
  // Guest side.
  PlansChanged = 1,
  TimeNotSuitable = 2,
  FoundAnotherPlace = 3,
  Other = 4,
  // Restaurant side.
  NoSuitableTable = 5,
  NotAnsweredInTime = 6,
}

export interface IReservationCancelCodeResponse {
  reservationId: string;
  codeLifetimeMinutes: number;
  phoneHint: string;
}

export interface IReservationCancelWithCodePayload {
  code: string;
  cancellationReason: CancellationReason;
  cancellationNote?: string;
}
